/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Atelier_BodyInputs */

const en_atelier_body = /** @type {(inputs: Atelier_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brands build their linesheets and suppliers answer Tomorrow's purchase orders on the same platform Tomorrow uses. A confirmation or a new date reaches Backstage the moment it is sent.`)
};

/**
* | output |
* | --- |
* | "Brands build their linesheets and suppliers answer Tomorrow's purchase orders on the same platform Tomorrow uses. A confirmation or a new date reaches Backst..." |
*
* @param {Atelier_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const atelier_body = /** @type {((inputs?: Atelier_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Atelier_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_atelier_body(inputs)
});